import { StyleSheet, css } from 'aphrodite'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import LandingSection from '../components/LandingSection'
import RoadmapSection from '../components/RoadmapSection'
import StatisticsSection from '../components/StatisticsSection'
import LandingFooter from '../components/navigation/LandingFooter'
import LandingHeader from '../components/navigation/LandingHeader'

export default function SustainabilityPage() {
  const navigate = useNavigate()

  const handleJoinCommunityClick = () => {
    window.scrollTo(0, 0)
    navigate('/register')
  }

  const statistics = [
    {
      value: '1M+',
      title: 'Unnecessary Miles Eliminated',
    },
  ]

  const roadmapItems = [
    {
      number: 1,
      title: 'Promoting Shared Usage Models For Hydrogen Fuel Cell Trucks',
      description:
        'We achieve lower costs, lower waste, and more access by encouraging efficient resource utilization across the Dump Truck Community.',
    },
    {
      number: 2,
      title: 'Supporting Hydrogen Infrastructure',
      description:
        'We are laying the groundwork for next-generation Dump Truck vehicles, sustainable transportation solutions, and the optimal infrastructure for the locations of hydrogen refueling stations.',
    },
    {
      number: 3,
      title: 'Data-Powered Decision-Making',
      description:
        'Use of digital insights to track and cut emissions across operations, enabling data-driven choices.',
    },
  ]

  return (
    <div className={css(styles.container)}>
      <LandingHeader />
      <LandingSection
        title="A SMARTER PATH TO NET ZERO"
        description="The Ecosystem is designed with sustainability at its core with an innovative emissions strategy. In 2021, the transportation sector was the largest source of greenhouse gas emissions in the U.S., contributing 29% of total output. Heavy-duty vehicles like Dump Trucks were responsible for 25% of that output — taking a toll not only on the 
communities, but on the environment and the economy."
        imageSrc="/sustainability_hero2.webp"
        imageAlt="Sustainability"
        buttonText="Join the Ecosystem"
        testimonialText="Trusted by 10,000+ operators,"
        userCount="contractors and haulers"
        onButtonClick={handleJoinCommunityClick}
        showCallToAction={false}
        subtitle="Sustainability"
      />
      <section className={css(styles.digitalPlatformSection)}>
        <div className="flex align-center items-center gap-16 flex-col md:flex-row">
          <div className={css(styles.digitalPlatformImageContainer)}>
            <img
              src="/emissions.webp"
              alt="Emissions"
              className={css(styles.digitalPlatformImage)}
              loading="lazy"
            />
          </div>
          <div className={css(styles.digitalPlatformContent)}>
            <h2 className={css(styles.digitalPlatformTitle)}>
              REDUCING MILES, REDUCING EMISSIONS
            </h2>
            <p className={css(styles.digitalPlatformDescription)}>
              By streamlining communication and cutting inefficiencies, the
              Ecosystem enables Drivers to eliminate unnecessary miles. Fewer
              miles mean less fuel, fewer emissions, and reduced negative
              environmental impact.
            </p>
            <p className={css(styles.digitalPlatformDescription)}>
              The Ecosystem uses innovative technology and data analytics to
              actively lower emissions — not by changing the truck, but by
              changing how it's used.
            </p>
          </div>
        </div>
      </section>
      <section className={css(styles.statsSection)}>
        <StatisticsSection stats={statistics} />
      </section>
      <RoadmapSection
        title="OUR SUSTAINABILITY ROADMAP"
        description="Roadmap to sustainability includes comprehensive initiatives that address both immediate and long-term environmental challenges in the Dump Truck Industry. The Community envisions:"
        items={roadmapItems}
        imageSrc="/roadmap.webp"
        imageAlt="Sustainability Roadmap"
      />
      <LandingSection
        title="JOIN US IN BUILDING A SUSTAINABLE FUTURE"
        description="Be part of the revolution that's transforming the Dump Truck Industry. Connect with thousands of verified operators, contractors, and haulers in a trusted digital community."
        imageSrc="/ecosystem.webp"
        imageAlt="Construction Team"
        buttonText="Join the Ecosystem"
        testimonialText="Trusted by 10,000+ operators,"
        userCount="contractors and haulers"
        onButtonClick={handleJoinCommunityClick}
      />
      <LandingFooter />
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    minHeight: '100vh',
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
  },
  digitalPlatformSection: {
    gap: '32px',
    alignItems: 'center',
    padding: '40px 1rem 0 1rem',
    '@media (min-width: 768px)': {
      gap: '40px',
      padding: '60px 2rem 0 2rem',
    },
    '@media (min-width: 1024px)': {
      gridTemplateColumns: '1fr 1fr',
      gap: '48px',
      padding: '80px 3rem 0 3rem',
    },
    '@media (min-width: 1280px)': {
      padding: '100px 5rem 0 5rem',
    },
  },
  digitalPlatformContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    textAlign: 'center',
    '@media (min-width: 768px)': {
      gap: '20px',
    },
    '@media (min-width: 1024px)': {
      gap: '24px',
      textAlign: 'left',
    },
  },
  digitalPlatformTitle: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '32px',
    fontWeight: 400,
    color: '#1F3D61',
    lineHeight: 1.2,
    '@media (min-width: 768px)': {
      fontSize: '48px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '60px',
    },
  },
  digitalPlatformDescription: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#4B5563',
    fontWeight: 400,
    '@media (min-width: 768px)': {
      fontSize: '16px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '18px',
    },
  },
  getStartedButton: {
    backgroundColor: '#6DC3FF',
    color: '#1F407E',
    padding: '12px 32px',
    borderRadius: '24px',
    fontSize: '16px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    width: '30%',
  },
  digitalPlatformImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    order: -1,
    '@media (min-width: 1024px)': {
      order: 0,
    },
  },
  digitalPlatformImage: {
    maxWidth: '100%',
    width: '100%',
    height: 'auto',
    maxHeight: '90vh',
    objectFit: 'contain',
    borderRadius: '16px',
    '@media (min-width: 768px)': {
      borderRadius: '20px',
      maxWidth: '90%',
    },
    '@media (min-width: 1024px)': {
      borderRadius: '24px',
      maxWidth: '100%',
    },
  },
  statsSection: {},
})
